import '../pages/Header.css';
import GTS from '../assets/GTS.svg';
import Divider from '../assets/Divider - Horizontal1.svg';
import Divider1 from '../assets/Divider - Horizontal.svg';
import Notification from '../assets/Notification.svg';
import Search from '../assets/Search.svg';
import Profile from '../assets/person-circleprofile.svg'
import { DropdownMenu, DropdownMenuItem } from '../components/ui/dropdown-menu';
import { useLocation, useNavigate } from 'react-router-dom';
import Help_outline from '../assets/help_outline.svg';
import Settings from '../assets/settings.svg';

function Header({ username, onSignOut, activeTab, searchTerm, setSearchTerm, messages }) {
    const navigate = useNavigate();
    const location = useLocation();
    return (
        <div className='container-fluid bottomBorder'>
            <div className='row'>
                <div className="col-12">
                    <div className='Layout'>
                        <span className='headerFrontText'>
                            <img src={GTS} alt="GTS Logo" className="gts-logo" />
                            <img src={Divider} alt="Divider" className="Divider" />
                            <span className='HeaderText'>AuracostAI</span>
                        </span>
                        <span className='headerEnd'>
                            <span className='LogoSearch'>
                                {(activeTab === 'tab4' || activeTab === 'tab1') && messages.length > 0 && (
                                    <div className="flex justify-center">
                                        <div className='chatbot-search'>
                                            <img src={Search} alt="Search" className="chatbot-SearchIcon ml-1" />
                                            <div className='chatbot-searchinput'>
                                                <input
                                                    type="text"
                                                    placeholder="Search Chats"
                                                    className="w-11/12"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <img src={Settings} alt="Search" className="Search" />

                                <img src={Help_outline} alt="Notification" className="Notification" />
                            </span>
                            <span>
                                <img src={Divider1} alt="Divider" className="Divider h-[72px]" />
                            </span>

                            <span className='rightText'>
                                <span className='UserName'>Hi, {username}</span>
                                <DropdownMenu label={<img src={Profile} alt="UserImage" className="UserImage cursor-pointer h-6 outline-none" />}>
                                    {location.pathname === '/adminPanel' && (
                                        <DropdownMenuItem onClick={() => navigate('/')}>
                                            Home
                                        </DropdownMenuItem>
                                    )}
                                    <DropdownMenuItem onClick={() => navigate('/adminPanel')}>
                                        AdminPanel
                                    </DropdownMenuItem>
                                    <DropdownMenuItem onClick={onSignOut}>
                                        Sign Out
                                    </DropdownMenuItem>
                                </DropdownMenu>
                                {/* <img src={UserImage} alt="UserImage" className="UserImage cursor-pointer" /> */}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;